import { memo, useCallback, useMemo, useState } from 'react';
import { images } from '../../assets';
import NewTicket from '../sections/NewTicket';

const Header = memo(() => {
  const [isTicketModalOpen, setIsTicketModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [createdTicketCode, setCreatedTicketCode] = useState('');
  const [mobileNavActive, setMobileNavActive] = useState(false);

  const toggleMobileNav = useCallback(() => {
    setMobileNavActive(prev => !prev);
    document.body.classList.toggle('mobile-nav-active');
  }, []);

  const closeMobileNav = useCallback(() => {
    if (mobileNavActive) {
      setMobileNavActive(false);
      document.body.classList.remove('mobile-nav-active');
    }
  }, [mobileNavActive]);

  const handleDropdownToggle = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    const parent = (e.currentTarget as HTMLElement).parentElement;
    const sibling = parent?.nextElementSibling;
    parent?.classList.toggle('active');
    sibling?.classList.toggle('dropdown-active');
  }, []);

  const whatsappLink = useMemo(() => {
    const text = `Hola, cree el ticket ${createdTicketCode} en Cloudata.`;
    return `https://wa.me/?text=${encodeURIComponent(text)}`;
  }, [createdTicketCode]);

  const handleTicketCreated = (ticketId: string) => {
    const ticketCode = `TK-${ticketId.slice(0, 8).toUpperCase()}`;
    setCreatedTicketCode(ticketCode);
    setIsSuccessModalOpen(true);
  };

  return (
    <>
      <header id="header" className="header d-flex align-items-center fixed-top">
        <div className="container-fluid container-xl position-relative d-flex align-items-center justify-content-between">
          <a href="#hero" className="logo d-flex align-items-center me-auto me-lg-0">
            <img src={images.logo} alt="Cloudata logo" />
            <span>.</span>
          </a>

          <nav id="navmenu" className="navmenu">
            <ul>
              <li>
                <a href="#hero" className="active" onClick={closeMobileNav}>
                  Inicio
                  <br />
                </a>
              </li>
              <li>
                <a href="#about" onClick={closeMobileNav}>Nosotros</a>
              </li>
              <li>
                <a href="#services" onClick={closeMobileNav}>Servicios</a>
              </li>
              <li>
                <a href="#team" onClick={closeMobileNav}>Por que elegirnos</a>
              </li>
              <li className="dropdown">
                <a href="#" onClick={(e) => e.preventDefault()}>
                  <span>Descargas</span> <i className="bi bi-chevron-down toggle-dropdown" onClick={handleDropdownToggle}></i>
                </a>
                <ul>
                  <li>
                    <a href="https://central.cloudata.cl/login" target="_blank" rel="noreferrer">
                      Central
                    </a>
                  </li>
                  <li>
                    <a href="https://clousys.dataminds.lat/login" target="_blank" rel="noreferrer">
                      Clousys
                    </a>
                  </li>
                  <li>
                    <a href="https://get.teamviewer.com/cloudata" target="_blank" rel="noreferrer">
                      TeamViewerQS
                    </a>
                  </li>
                  <li>
                    <a href="https://get.teamviewer.com/cloudatahost" target="_blank" rel="noreferrer">
                      TeamViewerHost
                    </a>
                  </li>
                  <li className="dropdown">
                    <a href="#" onClick={(e) => e.preventDefault()}>
                      <span>Navegadores</span> <i className="bi bi-chevron-down toggle-dropdown" onClick={handleDropdownToggle}></i>
                    </a>
                    <ul>
                      <li>
                        <a
                          href="https://www.google.com/chrome/browser/desktop/index.html"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Google Chrome
                        </a>
                      </li>
                      <li>
                        <a href="https://www.mozilla.org/es-CL/firefox/new/" target="_blank" rel="noreferrer">
                          Mozilla Firefox
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <a href="#" onClick={(e) => e.preventDefault()}>
                      <span>Utiles</span> <i className="bi bi-chevron-down toggle-dropdown" onClick={handleDropdownToggle}></i>
                    </a>
                    <ul>
                      <li>
                        <a
                          href="https://drive.google.com/file/d/0B3MPHLKQ3ZJLcms0MGhuaXVybnc/view?resourcekey=0-YUbydGXEUHD9QpH41KiaPg"
                          target="_blank"
                          rel="noreferrer"
                        >
                          WinScan2PDF
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://drive.google.com/file/d/0B3MPHLKQ3ZJLTW84WXVlUDd3Tjg/view?resourcekey=0-0Out4fub14v2qNw3As_I4Q"
                          target="_blank"
                          rel="noreferrer"
                        >
                          MailPV
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://drive.google.com/drive/folders/0B3MPHLKQ3ZJLQm4wZG5TNmZJWm8?resourcekey=0-ZHsn6OalX_wOdKqALVBEPw"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Otras descargas
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <a href="#contact" onClick={closeMobileNav}>Contacto</a>
              </li>
            </ul>
            <i
              className={`mobile-nav-toggle d-xl-none bi ${mobileNavActive ? 'bi-x' : 'bi-list'}`}
              onClick={toggleMobileNav}
            ></i>
          </nav>

          <div className="d-flex align-items-center">
            <a className="btn-getstarted" href="https://plataforma.clickgps.net/login" target="_blank" rel="noreferrer">
              GPS Plataforma
            </a>
            <button
              type="button"
              className="btn-getstarted"
              style={{ marginLeft: '10px', background: 'transparent' }}
              onClick={() => setIsTicketModalOpen(true)}
            >
              Nuevo Ticket
            </button>
          </div>
        </div>
      </header>

      <NewTicket isOpen={isTicketModalOpen} onClose={() => setIsTicketModalOpen(false)} onSuccess={handleTicketCreated} />

      {isSuccessModalOpen && (
        <>
          <div className="modal-backdrop show"></div>
          <div className="modal d-block" tabIndex={-1} role="dialog" aria-modal="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title d-flex align-items-center gap-2">
                    <i className="bi bi-ticket-perforated-fill text-warning"></i>
                    Ticket Creado
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Cerrar"
                    onClick={() => setIsSuccessModalOpen(false)}
                  ></button>
                </div>
                <div className="modal-body text-center">
                  <p className="mb-2">Tu ticket fue creado correctamente.</p>
                  <p className="ticket-number mb-4">{createdTicketCode}</p>
                  <a href={whatsappLink} target="_blank" rel="noreferrer" className="btn btn-success whatsapp-share-btn">
                    <i className="bi bi-whatsapp"></i>
                    Compartir por WhatsApp
                  </a>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setIsSuccessModalOpen(false)}>
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
});

Header.displayName = 'Header';

export default Header;

